export enum EndPoints {
  // start of index endpoints
  AccountTypes = "indexes/AccountTypes",
  Area = "indexes/Areas",
  GetArea = "indexes/Areas/Get",
  Days = "indexes/Days",
  Cities = "indexes/Cities",
  GetCities = "indexes/Cities/Get",
  Countries = "indexes/Countries",
  SelectAccountType = "indexes/AccountTypes",
  ContactTypes = "indexes/ContactTypes",
  Diseases = "indexes/Diseases",
  FrequencyTypes = "indexes/FrequencyTypes",
  SelectSpecialtyType = "indexes/Specialties",
  NotificationsTypes = "indexes/NotificationTypes",
  Manufactures = "indexes/Manufactures",
  DosageForm = "indexes/DosageForm",
  RelationType = "indexes/RelationType",
  GetFacilityTypes = "indexes/FacilityTypes",
  AppointmentStatuses = "indexes/AppointmentStatuses",
  Specialties = "indexes/Specialties",
  GetSpecialties = "indexes/Specialties/Get",
  Tutorials = "indexes/tutorials",
  GetMealTypes = "indexes/MealTypes",
  // end of index endpoints

  /****************************************************************************/

  // start of appointment endpoints
  CancelAppointment = "Appointment/Cancel",
  AddAppointmentForPatient = "Appointment/Create",
  GetMyAppointments = "Appointment/GetAppointments",
  AppointmentDetails = "Appointment/GetAppointment",
  GetHomeAppointments = "Appointment/GetHomeAppointments",
  GetMonthAppointments = "Appointment/GetMonthAppointments",
  GetReminderAppointments = "Appointment/GetReminderAppointments",
  GetLastAppointmentForPatient = "Appointment/GetLastAppointmentForPatient",
  // end of appointment endpoints

  /****************************************************************************/

  // start of prescription endpoints
  CreatePrescription = "Prescription/Create",
  GetPrescriptionToPatient = "Prescription/GetPrescriptionToPatient",
  getPrescriptionGroupByDoctors = "prescription/getPrescriptionGroupbyDoctos",
  GetPrescriptionsByDoctorIdForPatient = "Prescription/GetPrescriptionsByDoctorIdForPatient",
  GetPatientDrug = "Patients/GetPatientDrug",
  DeletePrescription = "Prescription/Delete",
  GetPrescriptions = "Prescription/Get",
  PrintPrescription = "Prescription/Print",
  ExternalPrintPrescription = "Prescription/ExternalPrint",
  DownloadPrescription = "prescription/download",
  // end of prescription endpoints

  /****************************************************************************/

  // start of general search endpoints
  ServiceProviderGroupedSearch = "ServiceProvider/SearchGrouped",
  SearchPatient = "ServiceProvider/SearchPatient",
  ServiceProvider = "ServiceProvider/Search",
  GetProviderCertificates = "ServiceProvider/GetProviderCertificates",
  GetFacilityProfile = "ServiceProvider/FacilityById",
  GetProviderProfile = "ServiceProvider/ProviderByFacilityId",
  // end of general search endpoints

  /****************************************************************************/

  // start of Medical history endpoints
  MedicalHistoryTypes = "MedicalHistory/MedicalHistoryTypes/Get",
  PrintMedicalRecord = "MedicalRecord/GenerateMedicalRecordPdf",
  MedicalRecordCreate = "MedicalRecord/Create",
  GetMedicalRecord = "MedicalRecord/Get",
  GetMostUsedMedicalHistoryType = "MedicalHistory/MedicalHistoryTypes/GetMostUsed",
  CreateMedicalHistoryTypes = "MedicalHistory/MedicalHistoryTypes/Create",
  CreateMedicalRecordFollowUp = "MedicalRecord/MedicalRecord/FollowUp",
  GetMedicalRecordFollowUps = "MedicalRecord/MedicalRecord/FollowUp",
  DeleteMedicalHistoryTypes = "MedicalHistory/MedicalHistoryTypes/Delete",
  AddMedicalRecordFile = "MedicalRecord/AddFile",
  MedicalRecordPdf = "MedicalRecordPdf/GenerateMedicalRecordWithFollowUpsPdf",
  UpdateMedicalHistory = "MedicalHistory/MedicalHistoryTypes/Update",
  GetMedicalRecordFile = "MedicalRecord/File",
  GetAllPatientMedicalRecords = "MedicalRecord/Get",
  PreviewMedicalReport = "MedicalRecord/Preview",
  GetFileTemp = "MedicalRecord/FileFromTemp",
  UpdateMedicalTemplate = "MedicalHistory/MedicalHistoryTypes/Update",
  GenerateMedicalRecordWithFollowUpsPdf = "MedicalRecordPdf/GenerateMedicalRecordWithFollowUpsPdf",
  // end of Medical history endpoints

  /****************************************************************************/

  // start of visit endpoints
  CreateVisit = "Visit/Create",
  GetAllVisit = "Visit/GetAll",
  GetVisitTemplate = "Visit/GetVisitTemplate",
  GetFollowUpById = "Visit/Get",
  // end of visit endpoints

  /****************************************************************************/

  // start of notification endpoints
  Notifications = "Notifications",
  NotificationHub = "notificationHub",
  MarkAsSeen = "Notifications/MarkAsSeen",
  DeleteNotifications = "Notifications/Delete",
  GetNotificationSetting = "Account/GetNotificationSetting",
  EditNotificationSetting = "Account/EditNotificationSetting",
  NotificationOpened = "Notifications/ResetNotificationCount",
  // end of notification endpoints

  /****************************************************************************/

  // start of relative endpoints
  MoveRelative = "Account/MoveRelative",
  CreateRelative = "Account/CreateRelative",
  GetRelative = "Account/GetRelative",
  ArchiveRelative = "Account/ArchiveRelative",
  UnArchiveRelative = "Account/UnArchiveRelative",
  MyRelative = "Account/GetRelative",
  CancelMoveRelative = "Account/CancelMoveRelative",
  // end of relative endpoints

  /****************************************************************************/

  // start of authentication endpoints
  CheckFromNumber = "Account/CheckFromNumber",
  ForgetPassword = "Account/ForgetPassword",
  ForgetPasswordSendCodeSMS = "Account/ForgetPassword/SendCode",
  ForgetPasswordCheckCode = "Account/ForgetPassword/CheckCode",
  ForgetPasswordCheckCodeLogedIn = "Account/ForgetPassword/CheckCodeLogedIn",
  ResetPassword = "Account/ForgetPassword/ResetPassword",
  SecurityQuestionCheck = "Account/ForgetPassword/Check",
  Login = "Account/Login",
  Register = "Account/Register",
  ResendCode = "Account/ResendCode",
  VerifyNumber = "Account/VerifyNumber",
  GetContactInfo = "Account/GetContact",
  ChangePhoneNumberRequest = "Account/ChangeNumber/Request",
  ChangePhoneNumber = "Account/ChangeNumber/NewNumber",
  verifyingCodeForNewNumber = "Account/ChangeNumber/VerifyCode",
  DeActivateAccount = "Account/DeleteAccount",
  ChangePassword = "Account/ChangePassword",
  ResendChangeNumberCodeSMS = "Account/ChangeNumber/ResendCode",
  ResendChangeNumberCodeWhatsApp = "Account/ChangeNumber/ResendCode",
  GetTimeToResendCode = "Account/GetTimeToResendCode",
  CheckPassword = "Account/CheckPassword",
  useGetTimeToResendCodeChangeNumber = "Account/ChangeNumber/GetTimeToResendCode",
  resendVerificationCodeChangeNumber = "Account/ChangeNumber/ResendCode",
  // end of authentication endpoints

  /****************************************************************************/

  // start of complete register endpoints
  CompleteRegister = "Account/CompleteRegister",
  CompleteHealthInfo = "Account/CompleteHealthInfo",
  CompleteLocationInfo = "Account/CompleteAddresstInfo",
  // end of complete register endpoints

  /****************************************************************************/

  // start of articles endpoints
  GetArticleById = "Articles/Get",
  GetAllArticles = "Articles/GetAll",
  // end of articles endpoints

  /****************************************************************************/

  // start of ads endpoints
  GetAllAds = "Ads/GetAll",
  // end of ads endpoints

  /****************************************************************************/

  // start of schedule endpoints
  EditSchedule = "Account/EditSchedule",
  GetSchedule = "Account/GetSchedule",
  GetScheduledDays = "Account/GetScheduledDays",
  InspectionDuration = "Account/EditInspectionDuration",
  GetAvailableScheduled = "Account/GetAvailableSchedules",
  // end of schedule endpoints

  /****************************************************************************/

  // start of patients endpoints
  GetMyPatient = "Patient/GetMyPatient",
  CreatePatient = "Patients/Create",
  UpdatePatient = "Patients/Update",
  UnlinkPatient = "Patient/Unlink",
  SearchMyPatients = "Patients/Mine/Search",
  GetPatients = "Patients/Get",
  PatientProfile = "Patients/Get",
  LinkPatient = "Patients/Link",
  PatientsReports = "Patient/PatientReports",
  AddReport = "Report/AddReport",
  // end of patients endpoints

  /****************************************************************************/

  // start of certificates endpoints
  GetCertificates = "Certificates/GetMine",
  Certificates = "Certificates/Add",
  EditCertificates = "Certificates/Edit",
  DeleteCertificate = "Certificates/Delete",
  // end of certificates endpoints

  /****************************************************************************/

  // start of specialty endpoints
  GetSpecialty = "Account/GetSpecialty",
  AddSpecialty = "Account/AddSpecialty",
  EditSpecialty = "Account/EditSpecialty",
  GetSpecialtyDoc = "Account/GetSpecialtyDoc",
  DeleteSpecialty = "Account/DeleteSpecialty",
  // end of specialty endpoints

  /****************************************************************************/

  // start of edit personal info endpoints
  GetAddress = "Account/GetAddress",
  EditAddress = "Account/EditAddress",
  EditContactInfo = "Account/EditContact",
  GetPrice = "Account/GetInspectionTarrif",
  EditPrice = "Account/EditInspectionTarrif",
  GetPersonalInfo = "Account/GetPersonalInfo",
  EditPersonalInfo = "Account/EditPersonalInfo",
  EditPregnancy = "Account/EditPregnancy",
  GetPregnancy = "Account/GetPregnancy",
  // end of edit personal info endpoints

  /****************************************************************************/

  // start of setting endpoints
  GetManagementContact = "Management/GetManagementContact",
  AddComplaint = "Complaint/Add",
  // end of setting endpoints

  /****************************************************************************/

  // start of search drugs endpoints
  SearchDrug = "SearchDrugs",
  // end of search drugs endpoints

  /****************************************************************************/
}
